<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="untitled-1"></div>
<div class="calibre1" id="untitled-111">
<div class="calibre1">
<p class="normal-229-0-override1"><span class="no-style-override1"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="normal-229-0-override"><span class="no-style-override2"><img alt="00004" src="Images/00004.jpeg"/><br class="calibre1"/></span></p>
<p class="calibre2" id="calibre_pb_4"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sub-title-page.vue?082d2cb4